import { render, staticRenderFns } from "./chartist.vue?vue&type=template&id=0486b578&"
import script from "./chartist.vue?vue&type=script&lang=js&"
export * from "./chartist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports